import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class TinyService {
constructor(private http: Http) { }

private tagsUrl = 'https://tin.siloq.com/';

tiny() {
          return this.http.get(this.tagsUrl + "tiny/srch")
 }
}



// WEBPACK FOOTER //
// ./src/app/services/tiny.service.ts